// Redirect all discussion urls to folio.procreate.art

export default (req, res, next) => {
    res.writeHead(301, { Location: `https://folio.procreate.art${req.originalUrl}` });
    res.end();
    
    return;
}